import type { Query } from '@vsf-enterprise/commercetools-types';
import type { ApiParams, Category } from '~/utils/ct';
import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';

export function useCategoryApi() {
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const search = async ({ customQuery, ...searchParams }: ApiParams): Promise<Category[]> => {
    const response = await makeCommercetoolsRequest<Query>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_CATEGORY,
      data: [
        searchParams,
        customQuery,
      ],
    });
    return response?.data?.categories?.results || [];
  };

  return {
    search,
  };
}
